import { doesNotHaveExpand, get } from "@insite/client-framework/Services/ApiService";
import { GetOrderApiParameter, GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { OrderCollectionModel, OrderModel } from "@insite/client-framework/Types/ApiModels";

const ordersUrl = "/api/v2/orderhistory/OrderHistoryCollection";
const orderDetailsUrl = "api/v2/orderhistory/OrderNoBasedOrderHistory";

function cleanOrderFieldNewLine(field: string) {
    // \r\n = CR + LF → Used as a new line character in Windows
    // \r = CR (Carriage Return) → Used as a new line character in Mac OS before X
    // \n = LF (Line Feed) → Used as a new line character in Unix/Mac OS X
    return field.trim().replace(/\r\n/gi, "").replace(/\r/gi, "").replace(/\n/gi, "");
}

function cleanOrder(orderModel: OrderModel, parameter?: { expand?: string[]; additionalExpands?: string[] }) {
    orderModel.orderDate = new Date(orderModel.orderDate);
    orderModel.id = cleanOrderFieldNewLine(orderModel.erpOrderNumber) || orderModel.webOrderNumber;
    if (doesNotHaveExpand(parameter, "orderLines")) {
        delete orderModel.orderLines;
    }

    if (!orderModel.shipViaDescription) {
        delete orderModel.shipViaDescription;
    }
}

export async function getOrdersFromERP(parameter: GetOrdersApiParameter): Promise<OrderCollectionModel> {
    // can't send empty status array to API
    if (parameter.status && parameter.status.length === 0) {
        delete parameter.status;
    }

    delete (parameter as any).onComplete;
    const orders = await get<OrderCollectionModel>(ordersUrl, parameter);
    orders.orders?.forEach(o => {
        cleanOrder(o, parameter);
    });
    return orders;
}

export async function getOrderFromERP(parameter: GetOrderApiParameter): Promise<OrderModel> {
    const { orderNumber, ...newParameter } = parameter;

    const order = await get<OrderModel>(`${orderDetailsUrl}/${orderNumber}`, newParameter);
    cleanOrder(order, parameter);
    return order;
}
